__turbopack_context__.v({
  "body": "WemapDrawerDefaultContent-module__w-baiW__body",
  "content": "WemapDrawerDefaultContent-module__w-baiW__content",
  "description": "WemapDrawerDefaultContent-module__w-baiW__description",
  "head": "WemapDrawerDefaultContent-module__w-baiW__head",
  "picture": "WemapDrawerDefaultContent-module__w-baiW__picture",
});
